import React from 'react';
import { Settings, Zap, LineChart, Rocket } from 'lucide-react';

const steps = [
  {
    icon: Settings,
    number: "01",
    title: "Configure Your Workflows",
    description: "Define business processes, data flows, and automation rules using our no-code builder."
  },
  {
    icon: Zap,
    number: "02",
    title: "Connect Your Systems",
    description: "Integrate existing tools and data sources. TradeEngine.AI becomes your central intelligence layer."
  },
  {
    icon: LineChart,
    number: "03",
    title: "Gain Real-Time Visibility",
    description: "Access live dashboards, alerts, and insights across all operations."
  },
  {
    icon: Rocket,
    number: "04",
    title: "Scale & Evolve",
    description: "Add new workflows and expand capabilities as your business grows."
  }
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="relative py-24 lg:py-32 bg-white dark:bg-slate-900 border-t border-slate-100 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-3xl mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 dark:text-white mb-4">
            From Setup to Success in Days
          </h2>
          <p className="text-lg text-slate-600 dark:text-slate-400">
            Traditional ERPs take months. TradeEngine.AI gets you operational in days, not weeks.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connection Line - Desktop */}
          <div className="hidden lg:block absolute top-20 left-[10%] right-[10%] h-px bg-slate-200 dark:bg-slate-700" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <div key={index} className="relative">
                  {/* Card */}
                  <div className="relative bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-200 dark:border-slate-800 p-6">
                    {/* Step Number */}
                    <div className="text-xs font-semibold text-orange-500 mb-4">
                      STEP {step.number}
                    </div>

                    {/* Icon */}
                    <div className="w-10 h-10 rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 flex items-center justify-center mb-4">
                      <Icon className="w-5 h-5 text-slate-600 dark:text-slate-400" />
                    </div>

                    {/* Content */}
                    <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {/* Connection Dot - Desktop */}
                  <div className="hidden lg:block absolute top-[80px] left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-orange-500 z-10" />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
